<template lang="pug">
.client-selector(@click="selectClient(client)")
  img(:src="platformImage[client]")
  .platform-name {{ platformName[client] }}
  .platform-bar
</template>

<script>
import { WINDOWS_LOGO, MACOS_LOGO, LINUX_LOGO } from '~/rails_assets';

export default {
  name: 'ClientSelector',
  props: {
    client: {
      type: String,
    },
  },
  computed: {
    platformImage() {
      return { Windows: WINDOWS_LOGO, 'Mac OS X': MACOS_LOGO, Linux: LINUX_LOGO };
    },
    platformName() {
      return { Windows: 'Windows', 'Mac OS X': 'macOS', Linux: 'Linux' };
    },
  },
  methods: {
    selectClient(platform) {
      this.$emit('select-client', platform);
    },
  },
};
</script>
